import Vue from 'vue'
import Router from 'vue-router'
import GoldAdmin from '@/components/gold-admin/GoldAdmin.vue'
import ProductSelection from '@/components/gold-admin/ProductSelection.vue'
import DesignProductAdmin from '@/components/product-designer/DesignProductAdmin.vue'

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/category/:categoryId/item/:itemId/:productId/:variantId',
      name: 'designer-view-variant',
      component: DesignProductAdmin
    },
    {
      path: '/category/:categoryId/item/:itemId/:productId',
      name: 'designer-view',
      component: DesignProductAdmin
    },
    {
      path: '/category/:categoryId/item/:itemId',
      component: GoldAdmin,
      children: [
        {path: '', name: 'product-listing', component: ProductSelection}
      ]
    },
    {
      path: '/category/:categoryId',
      name: 'item-selection',
      component: GoldAdmin
    },
    {
      path: '/',
      name: 'gold-admin',
      component: GoldAdmin
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./uncommon-client/router/index.js